<template>
  <div id="relationships_page" class="mx-28 my-32">
    <div class="flex">
      <el-select
        v-model="selectTeam"
        filterable
        placeholder="Select"
        class="input-style"
        :class="[ blurMode ?  'blurelement': '' ]"
        @change="handleTeams"
      >
        <el-option
          v-if="user.user_type !== 'leadership'"
          class="text-dropdown"
          :value="`All Teams (${optionsTeam.length})`"
        ></el-option>
        <el-option
          class="text-dropdown"
          :class="[ blurMode ?  'blurelement': '' ]"
          v-for="item in optionsTeam"
          :key="item.key"
          :label="item.name"
          :value="item.key"
        ></el-option>
      </el-select>
    </div>
    <div>
      <div class="fs-18 fw-700 mt-32">Organizational Network</div>
      <div class="fs-13 fc-747474 mt-6">
        Visualizing connections formed through peer/manager recognition, feedback exchanges, 
        and meaningful interactions over the past 6 months
      </div>
    </div>
    <div class="flex-center mt-16">
      <div class="label-input">Nodes</div>
      <div class="showOption showOption-40">
        <el-menu
          class="el-menu-demo menuOptionStyle"
          mode="horizontal"
          style="width: 210px"
        >
          <el-submenu index="0" style="width: 210px">
            <template slot="title">
              <span class="txtOption2">{{ profileSelectedName }}</span>
            </template>
            <template v-if="!blurMode">
              <el-menu-item
                v-for="(value, index) in profileNodesListFilter"
                :key="value + index"
                @click="profileSetting(value)"
                class="is-active"
                style="font-size: 16px; width: 210px"
                >{{ value.name }}
                </el-menu-item>
              {{ profileSetting(profileNodesList[0]) }}
            </template>
            <template v-else>
              {{ profileSetting(profileNodesList[4]) }}
            </template>
          </el-submenu>
        </el-menu>
      </div>
      <div class="label-input">Attribute</div>
      <div class="showOption showOption-40">
        <el-menu
          class="el-menu-demo menuOptionStyle"
          mode="horizontal"
          style="width: 210px"
        >
          <el-submenu index="0" style="width: 210px">
            <template slot="title">
              <span class="txtOption2">{{ attributeName }}</span>
            </template>
            <el-menu-item
              v-for="(value, index) in attributeList"
              :key="value + index"
              @click="attributeSetting(value)"
              class="is-active"
              style="font-size: 16px; width: 210px"
              >{{ value.name }}</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </div>
      <div class="label-input">Links</div>
      <div class="showOption showOption-40">
        <el-menu
          class="el-menu-demo menuOptionStyle"
          mode="horizontal"
          style="width: 210px"
        >
          <el-submenu index="0" style="width: 210px">
            <template slot="title">
              <span class="txtOption2">{{ linksName }}</span>
            </template>
            <el-menu-item
              v-for="(value, index) in linkList"
              :key="value + index"
              @click="linksSetting(value)"
              class="is-active"
              style="font-size: 16px; width: 210px"
              >{{ value.name }}</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <div class="mt-24 relative" style="height: 420px">
      <iframe
        v-if="iframeLinkCached"
        ref="iframeRef"
        id="iframeRef"
        :src="iframeLinkCached"
        class="thin-scrollbar iframe-container"
        :style="{ height: '100%', width: '100%' }"
        allow="fullscreen"
      ></iframe>
      <div
        @click="openFullscreen"
        class="absolute-btn-iframe flex-mid"
        style="bottom: 16px; right: 16px"
      >
        <img
          :src="$utils('icons', 'fullscreen_24dp')"
          alt="icons_fullscreen_24dp"
        />
      </div>
    </div>
    <div style="margin-top: 42px">
      <div class="flex-center">
        <div class="fs-18 fw-700">Relationship Attributes</div>
        <div class="flex-center" style="margin-left: 60px">
          <div>
            <el-dropdown
              trigger="click"
              :hide-on-click="false"
              ref="dropdownValuesMenu"
            >
              <!-- <img
                class="cursor-pointer"
                :src="$utils('icons', 'filter-list-24px')"
                alt="icons_filter-list-24px"
              /> -->
              <div class="text-drop-down flex-mid">
                <span v-if="arrDataCheck.length > 0">
                  ({{ arrDataCheck.length }})&nbsp;
                </span>
                <div>Signature</div>
                <div class="arrow ml-8">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="dropdownHeader">
                  <div>
                    <el-button
                      @click="handleSelectAllValues"
                      class="dropdownHeaderTextStyle"
                      type="text"
                      >{{ $t("powerUp.Select_all") }}</el-button
                    >
                    <el-button
                      @click="signatureType = []"
                      class="dropdownHeaderTextStyle"
                      style="margin-left: 24px"
                      type="text"
                      >{{ $t("powerUp.Clear") }}</el-button
                    >
                  </div>
                  <el-tooltip effect="dark" placement="top">
                    <div class="tooltipStyle" slot="content">
                      Filter by the signature value tagged in the relationships
                    </div>
                    <div class="flex-center">
                      <img
                        :src="$utils('icons', 'ic_help_outline-16px')"
                        alt="icons_ic_help_outline-16px"
                      />
                    </div>
                  </el-tooltip>
                </div>
                <div class="dropdownItem-tabActivity thin-scrollbar">
                  <el-checkbox-group v-model="signatureType">
                    <el-dropdown-item
                      v-for="item in signatureOption"
                      :key="item.type"
                    >
                      <el-checkbox :label="item.type" :key="item.type">{{
                        item.type
                      }}</el-checkbox>
                    </el-dropdown-item>
                  </el-checkbox-group>
                </div>
                <div class="dropdownFooter">
                  <el-button @click="clearValueSelected" type="cancel">{{
                    $t("powerUp.Cancel")
                  }}</el-button>
                  <el-button @click="saveValueFiltered" type="save">{{
                    $t("powerUp.Okay")
                  }}</el-button>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <div class="fs-12 fw-700 mr-12 ml-38">Sort by</div>
          <div class="showOption showOption-40">
            <el-menu
              class="el-menu-demo menuOptionStyle"
              mode="horizontal"
              style="width: 210px"
            >
              <el-submenu :index="`${selectMainPageSort}`" style="width: 210px">
                <template slot="title">
                  <span class="txtOption2">{{
                    tableFiterList[selectMainPageSort].name
                  }}</span>
                </template>
                <el-menu-item
                  v-for="(value, index) in tableFiterList"
                  :key="value + index"
                  :index="`${index}`"
                  @click="selectTableFillter"
                  class="is-active"
                  style="font-size: 16px; width: 210px"
                  >{{ value.name }}</el-menu-item
                >
              </el-submenu>
            </el-menu>
          </div> -->
        </div>
      </div>
      <div class="flex-center table-heaer-category">
        <div class="mr-auto"></div>
        <div class="box flex-mid" style="width: 296px">Connections</div>
        <div class="box flex-mid ml-12" style="width: 100px">Engagement</div>
        <div class="box flex-mid ml-12" style="width: 255px">Signatures</div>
      </div>
      <div>
        <div class="mt-16 relationship-table">
          <el-table
            :default-sort="{ prop: 'total_count', order: 'descending' }"
            ref="multipleTable"
            :data="datalist"
            style="width: 100%"
            :empty-text="` `"
            @sort-change="Sort"
          >
            <el-table-column
              width="260"
              sortable
              prop="fullName"
              label="Name, Team"
            >
              <template slot-scope="scope">
                <div class="flex-center">
                  <img
                    v-if="scope.row.profileImage"
                    v-lazy="scope.row.profileImage"
                    :key="scope.row.profileImage"
                    class="image-skeleton image-profile-42 flex-mid mr-12"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                  <div v-else class="image image-profile-42 flex-mid mr-12"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <div class="text-in-image text-in-image-42 flex-mid">
                      {{
                        $utils("acronymName", { fullName: scope.row.fullName })
                      }}
                    </div>
                  </div>
                  <div
                    class="fc-000000 ellipsis"
                    style="line-height: 16px; width: 186px"
                  >
                    <div class="fs-14 fw-700 ellipsis"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      {{ scope.row.fullName }}
                    </div>
                    <div class="fs-13 fw-700 opa-06 ellipsis"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      {{ scope.row.teamName }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="75"
              sortable
              prop="total_count"
              label="Total"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.total_count > 0"
                  class="center value-line flex-mid pb-4"
                  @click="openConnectionsView('Total', scope.row)"
                >
                  {{ scope.row.total_count }}
                </div>
                <div v-else class="center value-no-line flex-mid pb-4">
                  {{ scope.row.total_count }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="75"
              sortable
              prop="inner_count"
              label="Inner"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.inner_count > 0"
                  class="center value-line flex-mid pb-4"
                  @click="openConnectionsView('Inner', scope.row)"
                >
                  {{ scope.row.inner_count }}
                </div>
                <div v-else class="center value-no-line flex-mid pb-4">
                  {{ scope.row.inner_count }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="80"
              sortable
              prop="outer_count"
              label="Outer"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.outer_count > 0"
                  class="center value-line flex-mid pb-4"
                  @click="openConnectionsView('Outer', scope.row)"
                >
                  {{ scope.row.outer_count }}
                </div>
                <div v-else class="center value-no-line flex-mid pb-4">
                  {{ scope.row.outer_count }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="80"
              sortable
              prop="strong_count"
              label="Strong"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.strong_count > 0"
                  class="center value-line flex-mid pb-4"
                  @click="openConnectionsView('Strong', scope.row)"
                >
                  {{ scope.row.strong_count }}
                </div>
                <div v-else class="center value-no-line flex-mid pb-4">
                  {{ scope.row.strong_count }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="120"
              sortable
              prop="me_ratio"
              :render-header="renderMERatioHeader"
            >
              <template slot-scope="scope">
                <div class="flex-mid">
                  <div
                    class="center flex-mid pb-4"
                    v-bind:class="renderME_Ratio_BGColor(scope.row.me_ratio)"
                  >
                    {{ scope.row.me_ratio >= 0 ? scope.row.me_ratio : "-" }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="230"
              sortable
              prop="signatures_count"
              label="Types"
            >
              <template slot-scope="scope">
                <div class="flex type-container">
                  <div
                    v-for="value in scope.row.signatures"
                    :key="value.id + scope.row.email"
                  >
                    <el-tooltip placement="top">
                      <div
                        slot="content"
                        class="fw-400 fs-12"
                        style="width: 220px"
                      >
                        {{ mappingSignatures(value.id, "tooltip") }}
                      </div>
                      <div :class="`type-box${value.color} flex-center`">
                        <img
                          v-if="mappingSignatures(value.id, 'icon')"
                          :src="
                            $utils('icons', mappingSignatures(value.id, 'icon'))
                          "
                          class="icon"
                          alt="icons_sig_bridge"
                        />
                        <div v-else class="icon"></div>
                        <div class="label">{{ value.name }}</div>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-if="loadingRaltionshipTable"
            class="center relative"
            style="margin-top: -60px; z-index: 99"
          >
            <div
              v-for="value in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
              :key="'mock_data_on_loading_' + value"
              class="flex-center loading-member-table opa-06"
              :style="`height: 54px; animation-duration: ${value * 1.5 + 1}s`"
            >
              <div class="flex-mid ml-10">
                <div class="image-skeleton image-profile-42 opa-06"></div>
              </div>
              <div class="pl-38" style="width: 174px">
                <div class="text-skeleton fs-14" style="width: 130px">
                  &nbsp;
                </div>
                <div
                  class="text-skeleton fs-14 opa-06 mt-6"
                  style="width: 120px"
                >
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 80px">
                <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 80px">
                <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 75px">
                <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 75px">
                <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 130px">
                <div
                  class="text-skeleton fs-20 mr-20"
                  style="width: 32px; border-radius: 20px"
                >
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 160px">
                <div class="text-skeleton fs-22 mr-8" style="width: 100px">
                  &nbsp;
                </div>
                <div
                  class="text-skeleton fs-22 mr-auto"
                  style="width: 40px; border-radius: 4px"
                >
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="flex-center pagination mt-10 relative"
            style="z-index: 99"
          >
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-size="10"
              :pager-count="5"
              layout="prev, pager, next"
              :total="datalistAll.length"
            ></el-pagination>
            <span class="results-status">
              {{ datalist.length > 10 ? 10 : datalist.length }}
              {{ $t("insights.results_from") }}
              {{ $utils("addCommasInNumber", datalistAll.length) }}
              {{ $t("insights.results") }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="remove-padding-modal">
      <el-dialog :visible.sync="connectionsViewModal" width="990px" top="8vh">
        <div class="p-32">
          <div>
            <div class="fs-18 fw-700 fc-00000" style="color: #000"
            :class="[ blurMode ?  'blurelement': '' ]">
              {{ modalData.name }}'s {{ modalData.type }} Connections
            </div>
          </div>
          <div class="flex-center table-heaer-category">
            <div class="mr-auto"></div>
            <div class="box flex-mid" style="width: 296px">Connections</div>
            <div class="box flex-mid ml-12" style="width: 100px">
              Engagement
            </div>
            <div class="box flex-mid ml-12" style="width: 255px">
              Signatures
            </div>
          </div>
          <div>
            <div class="mt-16 relationship-table">
              <el-table
                ref="multipleTable"
                :data="tableConnectionsData"
                style="width: 100%"
                mx-height="720"
                :empty-text="` `"
              >
                <el-table-column
                  width="260"
                  sortable
                  prop="fullName"
                  label="Name, Team"
                >
                  <template slot-scope="scope">
                    <div class="flex-center">
                      <img
                        v-if="scope.row.profileImage"
                        v-lazy="scope.row.profileImage"
                        :key="scope.row.profileImage"
                        class="image-skeleton image-profile-42 flex-mid mr-12"
                        :class="[ blurMode ?  'blurelement': '' ]"
                      />
                      <div v-else class="image image-profile-42 flex-mid mr-12"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        <div class="text-in-image text-in-image-42 flex-mid">
                          {{
                            $utils("acronymName", {
                              fullName: scope.row.fullName,
                            })
                          }}
                        </div>
                      </div>
                      <div
                        class="fc-000000 ellipsis"
                        style="line-height: 16px; width: 186px"
                      >
                        <div class="fs-14 fw-700 ellipsis"
                        :class="[ blurMode ?  'blurelement': '' ]">
                          {{ scope.row.fullName }}
                        </div>
                        <div class="fs-13 fw-700 opa-06 ellipsis"
                        :class="[ blurMode ?  'blurelement': '' ]">
                          {{ scope.row.teamName }}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="75"
                  sortable
                  prop="total_count"
                  label="Total"
                >
                  <template slot-scope="scope">
                    <div
                      v-if="scope.row.total_count > 0"
                      class="center value-line flex-mid pb-4"
                      @click="openConnectionsView('Total', scope.row)"
                    >
                      {{ scope.row.total_count }}
                    </div>
                    <div v-else class="center value-no-line flex-mid pb-4">
                      {{ scope.row.total_count }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="75"
                  sortable
                  prop="inner_count"
                  label="Inner"
                >
                  <template slot-scope="scope">
                    <div
                      v-if="scope.row.inner_count > 0"
                      class="center value-line flex-mid pb-4"
                      @click="openConnectionsView('Inner', scope.row)"
                    >
                      {{ scope.row.inner_count }}
                    </div>
                    <div v-else class="center value-no-line flex-mid pb-4">
                      {{ scope.row.inner_count }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="80"
                  sortable
                  prop="outer_count"
                  label="Outer"
                >
                  <template slot-scope="scope">
                    <div
                      v-if="scope.row.outer_count > 0"
                      class="center value-line flex-mid pb-4"
                      @click="openConnectionsView('Outer', scope.row)"
                    >
                      {{ scope.row.outer_count }}
                    </div>
                    <div v-else class="center value-no-line flex-mid pb-4">
                      {{ scope.row.outer_count }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="80"
                  sortable
                  prop="strong_count"
                  label="Strong"
                >
                  <template slot-scope="scope">
                    <div
                      v-if="scope.row.strong_count > 0"
                      class="center value-line flex-mid pb-4"
                      @click="openConnectionsView('Strong', scope.row)"
                    >
                      {{ scope.row.strong_count }}
                    </div>
                    <div v-else class="center value-no-line flex-mid pb-4">
                      {{ scope.row.strong_count }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="120"
                  sortable
                  prop="me_ratio"
                  label="M/E Ratio"
                >
                  <template slot-scope="scope">
                    <div class="flex-mid">
                      <div
                        class="center flex-mid pb-4"
                        v-bind:class="
                          renderME_Ratio_BGColor(scope.row.me_ratio)
                        "
                      >
                        {{ scope.row.me_ratio >= 0 ? scope.row.me_ratio : "-" }}
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="230"
                  sortable
                  prop="signatures_count"
                  label="Types"
                >
                  <template slot-scope="scope">
                    <div class="flex type-container">
                      <div
                        v-for="value in scope.row.signatures"
                        :key="value.id + scope.row.email"
                      >
                        <el-tooltip placement="top">
                          <div
                            slot="content"
                            class="fw-400 fs-12"
                            style="width: 220px"
                          >
                            {{ mappingSignatures(value.id, "tooltip") }}
                          </div>
                          <div :class="`type-box${value.color} flex-center`">
                            <img
                              :src="
                                $utils(
                                  'icons',
                                  mappingSignatures(value.id, 'icon')
                                )
                              "
                              class="icon"
                              alt="icons_sig_bridge"
                            />
                            <div class="label">{{ value.name }}</div>
                          </div>
                        </el-tooltip>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div
                v-if="loadingConnectionsTable"
                class="center relative"
                style="margin-top: -60px; z-index: 99"
              >
                <div
                  v-for="value in [1, 2, 3, 4]"
                  :key="'mock_data_on_loading_' + value"
                  class="flex-center loading-member-table opa-06"
                  :style="`height: 54px; animation-duration: ${
                    value * 1.5 + 1
                  }s`"
                >
                  <div class="flex-mid ml-10">
                    <div class="image-skeleton image-profile-42 opa-06"></div>
                  </div>
                  <div class="pl-38" style="width: 174px">
                    <div class="text-skeleton fs-14" style="width: 130px">
                      &nbsp;
                    </div>
                    <div
                      class="text-skeleton fs-14 opa-06 mt-6"
                      style="width: 120px"
                    >
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 80px">
                    <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 80px">
                    <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 75px">
                    <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 75px">
                    <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 130px">
                    <div
                      class="text-skeleton fs-20 mr-20"
                      style="width: 32px; border-radius: 20px"
                    >
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 160px">
                    <div class="text-skeleton fs-22 mr-8" style="width: 100px">
                      &nbsp;
                    </div>
                    <div
                      class="text-skeleton fs-22 mr-auto"
                      style="width: 40px; border-radius: 4px"
                    >
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog 
        :visible.sync="relationShipsModal" 
        width="90vw" 
        top="6vh"
        :fullscreen="true"
        :show-close="false"
        custom-class="relationships-fullscreen-dialog"
        @open="handleFullscreenOpen"
        @close="handleFullscreenClose"
      >
        <div class="relative fullscreen-container">
          <iframe
            ref="fullscreenIframeRef"
            id="fullscreenIframeRef"
            :src="iframeLink + '&mode=fullscreen'"
            class="thin-scrollbar iframe-container fullscreen-iframe"
          ></iframe>
          <div
            @click="closeFullscreen"
            class="absolute-btn-iframe flex-mid"
          >
            <img
              :src="$utils('icons', 'close_fullscreen_24dp')"
              alt="icons_close_fullscreen_24dp"
            />
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "relationships",
  created() {
    this.$store.dispatch("relationships/getOrganization");
  },
  watch: {
    organization1level() {
      if (Object.keys(this.organization1level).length > 0) {
        this.$store.dispatch("relationships/getAttributeData", this.user);
      }
    },
    selectTeam() {
      if (this.optionsTeam.length > 0) {
        this.reranderIframe = false;
        this.$store.commit("relationships/setIframeLink", {
          team: this.selectTeam,
          company: this.user.company,
        });
        setTimeout(() => {
          // this.$store.commit("relationships/setLoadingRelationshipsTabs", false);
          this.reranderIframe = true;
        }, 100);
      }
    },
    profileSelected(value) {
      if (value) {
        this.$store.commit("relationships/setNodes", value);
      }
    },
    attribute(value) {
      if (value) {
        this.$store.commit("relationships/setAttribute", value);
      }
    },
    links(value) {
      if (value) {
        this.$store.commit("relationships/setLinks", value);
      }
    },
    iframeLink(link) {
      if (link) {
        if (!this.iframeLoaded) {
          this.iframeLoaded = true;
          this.iframeLinkCached = link;
        } else {
          // Store the current state when updating iframe
          this.currentIframeState = this.parseIframeParams(link);
          this.onLoadIframe(link);
        }
      }
    },
  },
  data() {
    return {
      modalData: {
        name: "",
        type: "",
      },
      reranderIframe: true,
      profileSelected: "initials",
      profileSelectedName: "Initials & Team",
      profileNodesList: [
        {
          name: "Initials & Team",
          value: "initials_team",
        },
        // {
        //   name: "Initials & Cohort ⚒",
        //   value: "initials_cohort",
        // },
        {
          name: "Initials",
          value: "initials",
        },
        {
          name: "Profile Photo",
          value: "profile_photo",
        },
        {
          name: "None",
          value: "none",
        },
        {
          name: "Blurred",
          value: "blurred",
        }
      ],
      attribute: "impact_rating",
      attributeName: "Impact Rating",
      attributeList: [
        {
          name: "Impact Rating",
          value: "impact_rating",
        },
        {
          name: "Happiness",
          value: "happiness",
        },
        {
          name: "Well-being",
          value: "well-being",
        },
        {
          name: "eNPS",
          value: "eNPS",
        },
        {
          name: "NPS",
          value: "NPS",
        },
        {
          name: "Culture Index",
          value: "culture_index",
        },
        {
          name: "Toxic Behaviors",
          value: "toxic_behaviors",
        },
      ],
      links: "All Relational Data",
      linksName: "All Relational Data",
      linkList: [
        {
          name: "All Relational Data",
          value: "all_relational_data",
        },
        {
          name: "Meaningful Interactions Only",
          value: "meaningful_interactions_only",
        },
        {
          name: "Line of Management Only",
          value: "line_of_management_only",
        }
        // {
        //   name: "Only Peer Recognition",
        //   value: "only_peer_recognition",
        // },
        // {
        //   name: "Only Manager Recognition",
        //   value: "only_manager_recognition",
        // },
        // {
        //   name: "Only Manager feedback",
        //   value: "only_manager_feedback",
        // },
      ],
      tableFiter: "",
      tableFiterName: "",
      tableFiterList: [
        {
          name: "Most Total Connections",
          value: "totalArrData",
        },{
          name: "Most Inner Connections",
          value: "innerArrData",
        },{
          name: "Most Outer Connections",
          value: "outerArrData",
        },
        {
          name: "Most Strong Connections",
          value: "strongArrData",
        },
      ],
      selectMainPageSort: 0,
      loadingRaltionshipTable: true,
      // tableRalationshipAttributesData: [],
      loadingConnectionsTable: false,
      tableConnectionsData: [],
      connectionsViewModal: false,
      relationShipsModal: false,
      signatureType: [],
      signatureOption: [
        { type: "Brokerage" },
        { type: "Cohesion" },
        { type: "Connectivity" },
        { type: "Collective" },
        { type: "Influence" },
        { type: "Reachability" },
        { type: "Ripple" },
        { type: "Hub" },
        { type: "Strategist" },
        { type: "Community Leader" },
        { type: "Linker" },
      ],
      arrDataCheck: [],
      // iframeLoaded: true,
      // iframeLinkCached: "http://localhost:8081/relationships-network?company=-Kv0X8SSurYL3y1MZAWL&team=-L0Dg4P9voDNUxuEH8UV&nodes=initals&attribute=impact_rating&links=all_relational_data",
      iframeLoaded: false,
      iframeLinkCached: "",
      currentIframeState: null,
    };
  },
  mounted() {
    if (this.optionsTeam.length > 0 && this.selectTeam == "") {
      this.selectTeam =
        this.user.user_type == "leadership" ? this.user.team : "";
      this.$store.commit("relationships/setTeamId", {
        keyword: `All Teams (${optionsTeam.length})`,
      });
    }
    setTimeout(() => {
      this.loadData();
    }, 3000);
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    organization1level() {
      return this.$store.getters["relationships/organization1level"];
    },
    datalistAll() {
      return this.$store.getters["relationships/datalistAll"];
    },
    datalist() {
      return this.$store.getters["relationships/datalist"];
    },
    page() {
      return this.$store.getters["relationships/page"];
    },
    signatures() {
      return this.$store.getters["relationships/signatures"];
    },
    // loadingRelationshipsTabs() {
    //   return this.$store.getters["relationships/loadingRelationshipsTabs"];
    // },
    selectTeam: {
      get() {
        if (this.optionsTeam.length > 0) {
          return this.$store.getters["relationships/selectTeam"];
        }
      },
      set(value) {
        if (this.optionsTeam.length > 0) {
          this.$store.commit("relationships/setTeamId", { keyword: value });
        }
      },
    },
    optionsTeam() {
      const optionsTeam = this.$store.getters["team/teamsall"];
      if (this.user.user_type == "leadership") {
        this.$store.commit("relationships/setTeamId", {
          keyword: this.user.team,
        });
      } else {
        this.$store.commit("relationships/setTeamId", {
          keyword: `All Teams (${optionsTeam.length})`,
        });
      }
      return optionsTeam;
    },
    iframeLink() {
      return this.$store.getters["relationships/iframeLink"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    profileNodesListFilter() {
      return this.profileNodesList.filter((f) => f.value !== "blurred");
    },
  },
  methods: {
    handleTeams(key) {
      this.$store.dispatch("relationships/getDataTable", this.selectTeam);
      //this.$store.dispatch("insightsManagers/getDataOverview", team);
      //this.$store.dispatch("insightsManagers/changeTeam", team);
    },
    parseIframeParams(url) {
      const params = new URL(url).searchParams;
      return {
        company: params.get("company"),
        team: params.get("team"),
        nodes: params.get("nodes"),
        attribute: params.get("attribute"),
        links: params.get("links")
      };
    },
    async onLoadIframe(url) {
      const params = new URL(url).searchParams;
      const data = {
        type: "updateParams",
        data: {
          company: params.get("company"),
          team: params.get("team"),
          nodes: params.get("nodes"),
          attribute: params.get("attribute"),
          links: params.get("links"),
          isFullscreen: this.relationShipsModal
        },
      };

      // Wait for iframe to be ready
      await this.$nextTick();
      const iframe = this.relationShipsModal ? this.$refs.fullscreenIframeRef : this.$refs.iframeRef;
      
      if (iframe && iframe.contentWindow) {
        try {
          iframe.contentWindow.postMessage(data, "*");
        } catch (error) {
          console.error("Error posting message to iframe:", error);
        }
      }
    },
    loadData() {
      this.loadingRaltionshipTable = false;
      // this.tableRalationshipAttributesData.push({
      //   cuttingName: "AY",
      //   email: "aphisit_y@dhas.com",
      //   fullName: "Aphisit Yolai",
      //   name: "Aphisit Y",
      //   profileImage:
      //     "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fprofiles%2Faphisit_y%40dhas.com.jpg?rand=396031358&alt=media",
      //   teamColor: "#747474",
      //   teamId: "-L4KmX2AFkj-biuFzq9p",
      //   teamName: "IT / Technical Team",
      //   total_count: 24,
      //   inner_count: 16,
      //   outer_count: 8,
      //   strong_count: 4,
      //   me_ratio: 2.5,
      //   signatures: [
      //     {
      //       name: "Ideator",
      //       id: "Ideator",
      //     },
      //   ],
      // });
    },
    renderColor(code) {
      if (code) {
        let color = code.replace(/#/g, "");
        return `bg-${color}`;
      } else {
        return "bg-747474";
      }
    },
    openConnectionsView(type, data) {
      this.modalData.name = data.fullName;
      this.modalData.type = type;

      this.tableConnectionsData = [];
      this.loadingConnectionsTable = true;

      this.connectionsViewModal = true;
      setTimeout(() => {
        if (type == "Inner") {
          this.tableConnectionsData = data.innerArrData;
        } else if (type == "Outer") {
          this.tableConnectionsData = data.outerArrData;
        } else if (type == "Strong") {
          this.tableConnectionsData = data.strongArrData;
        } else if (type == "Total") {
          this.tableConnectionsData = data.totalArrData;
        }
        this.loadingConnectionsTable = false;
      }, 3000);
    },
    handleCurrentChange(val) {
      this.$store.dispatch("relationships/currentChange", val);
    },
    Sort({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("relationships/sort", [column.property, order]);
      }
      this.handleCurrentChange(this.page);
    },
    profileSetting(value) {
      this.profileSelected = value.value;
      this.profileSelectedName = value.name;
    },
    attributeSetting(value) {
      this.attribute = value.value;
      this.attributeName = value.name;
    },
    linksSetting(value) {
      this.links = value.value;
      this.linksName = value.name;
    },
    selectTableFillter(row) {
      this.selectMainPageSort = row.index;
      const order = row.index
      if (order == 0) {
        this.$store.dispatch("relationships/sort", ['total_count', 'descending']);
      }else if(order == 1){
        this.$store.dispatch("relationships/sort", ['inner_count', 'descending']);
      }else if(order == 2){
        this.$store.dispatch("relationships/sort", ['outer_count', 'descending']);
      }else if(order == 3){
        this.$store.dispatch("relationships/sort", ['strong_count', 'descending']);
      }
      this.handleCurrentChange(this.page);

      // console.log("selectTableFillter", value);
      // this.tableFiter = value.value;
      // this.tableFiterName = value.name;
    },
    renderME_Ratio_BGColor(value) {
      if (value >= 1.0) {
        return "green me-ratio";
      } else if (value >= 0.6 && value < 1.0) {
        return "yellow me-ratio";
      } else if (value >= 0 && value < 0.6) {
        return "red me-ratio";
      }
    },
    mappingSignatures(id, type) {
      const tooltipList = this.signatures;

      // mapping data with id
      const signatures = tooltipList.find(
        (item) => item.id.toLowerCase() === id.toLowerCase()
      );
      return signatures ? signatures[type] : "";
    },
    handleSelectAllValues() {
      if (this.signatureType.length !== this.signatureOption.length) {
        let checked = [];
        for (const i in this.signatureOption) {
          checked.push(this.signatureOption[i].type);
        }
        this.signatureType = checked;
      }
    },
    clearValueSelected() {
      this.signatureType = this.arrDataCheck;
      this.$refs.dropdownValuesMenu.visible = false;
      this.$store.dispatch("relationships/filter", this.signatureType);
    },
    saveValueFiltered() {
      this.arrDataCheck = this.signatureType;
      this.$refs.dropdownValuesMenu.visible = false;
      this.$store.dispatch("relationships/filter", this.signatureType);

      // this.$store.commit("activity/setFilter", true);
      // this.$store.commit("activity/setActivity", []);
      // this.$store.dispatch("activity/getdatafilter", {core_value:this.checkedTalentType,classification:this.checkedArrClassificationCheck,reward:this.checkedArrRewardTypeCheck});
    },
    renderMERatioHeader(creatElement, { column, $index }) {
      return (
        <el-tooltip content="Top center" placement="top">
          <div slot="content" style="width: 240px">The M/E Ratio is the ratio of the direct manager's and employee's total connections. A manager plays an important role of initiating connections for their team. Employees with low M/E ratios are more often disengaged due to a high difference in network value between them and their direct manager.</div>
          <span>M/E Ratio</span>
        </el-tooltip>
      );
    },
    openFullscreen() {
      this.relationShipsModal = true;
    },
    handleFullscreenOpen() {
      // Store current state before entering fullscreen
      if (this.iframeLink) {
        this.currentIframeState = this.parseIframeParams(this.iframeLink);
      }
      
      // Update iframe with fullscreen mode
      this.onLoadIframe(this.iframeLink + '&mode=fullscreen');
      
      // Add keyboard listener for ESC key
      document.addEventListener('keydown', this.handleEscKey);
    },
    handleFullscreenClose() {
      // Remove keyboard listener
      document.removeEventListener('keydown', this.handleEscKey);
      
      // Reconstruct URL with stored state
      if (this.currentIframeState) {
        const params = new URLSearchParams();
        Object.entries(this.currentIframeState).forEach(([key, value]) => {
          if (value) params.append(key, value);
        });
        
        const baseUrl = this.iframeLinkCached.split('?')[0];
        const newUrl = `${baseUrl}?${params.toString()}`;
        
        // Update main iframe with preserved state
        this.onLoadIframe(newUrl);
      }
    },
    closeFullscreen() {
      this.relationShipsModal = false;
    },
    handleEscKey(event) {
      if (event.key === 'Escape') {
        this.closeFullscreen();
      }
    },
  },
  beforeDestroy() {
    // Clean up event listeners
    document.removeEventListener('keydown', this.handleEscKey);
  },
};
</script>

<style lang="scss" scoped>
.iframe-container {
  width: 100%;
  max-height: 420px;
  border-radius: 24px;
  border: none;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.fullscreen-container {
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
}

.fullscreen-iframe {
  max-height: none;
  height: 100%;
  border-radius: 0;
}

.relationships-fullscreen-dialog {
  margin: 0 !important;
  
  :deep(.el-dialog__body) {
    padding: 0;
    height: 100vh;
  }
}

.absolute-btn-iframe {
  position: absolute;
  bottom: 26px;
  right: 26px;
  cursor: pointer;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
  
  img {
    width: 24px;
    height: 24px;
  }
}

.label-input {
  font-size: 14px;
  font-weight: 700;
  margin-right: 12px;
}
.menuOptionStyle {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
  margin-right: 16px;
}
.txtOption2 {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 154px;
  display: inline-block;
}

.table-heaer-category {
  margin-top: 24px;
  .box {
    background-color: rgba($color: #000000, $alpha: 0.02);
    border-radius: 4px;
    color: #454545;
    font-size: 12px;
    font-weight: 500;
    padding-top: 4px;
    padding-bottom: 4px;
  }
}

.value-line {
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  color: #000;
  cursor: pointer;
}
.value-no-line {
  font-size: 14px;
  font-weight: 500;
  color: #000;
}
.me-ratio {
  padding: 0 6px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
  background: #ccc;
}
.me-ratio.green {
  background: rgba($color: #66bb6a, $alpha: 0.3);
  color: #28642a;
}
.me-ratio.yellow {
  background: rgba($color: #fbc02d, $alpha: 0.3);
  color: #745301;
}
.me-ratio.red {
  background: rgba($color: #f44336, $alpha: 0.3);
  color: #6e1d17;
}
.type-container {
  gap: 4px 7px;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
}
.type-box-blue {
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 4px;
  background-color: rgba($color: #236BDD, $alpha: 0.15);
  padding: 4px 8px 2px;
  margin-bottom: 6px;
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .label {
    color: #2f0c67;
    font-size: 13px;
    font-weight: 500;
  }
}
.type-box {
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 4px;
  background-color: rgba($color: #6c30cc, $alpha: 0.15);
  padding: 4px 8px 2px;
  margin-bottom: 6px;
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .label {
    color: #2f0c67;
    font-size: 13px;
    font-weight: 500;
  }
}
.dropdownHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding-left: 24px;
  padding-right: 16px;
  margin-bottom: 10px;
  background: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
}

.dropdownHeaderTextStyle {
  font-size: 13px;
  font-weight: 700;
}

.el-button--text.dropdownHeaderTextStyle {
  color: #32c2d5;
}

.el-button--text.dropdownHeaderTextStyle:hover {
  color: #249fb0;
}

.el-button--text.dropdownHeaderTextStyle:active {
  color: #32c2d5;
}

.tooltipStyle {
  max-width: 240px;
}

.dropdownFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 56px;
  padding-right: 16px;
  background: #f8f8f8;
  border-top: 1px solid #e8e8e8;

  .el-button--cancel {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
  }

  .el-button--cancel:hover,
  .el-button--cancel:focus {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 0.7;
  }

  .el-button--cancel:active {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 1;
  }

  .el-button--save {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
  }

  .el-button--save:hover,
  .el-button--save:focus {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 0.7;
  }

  .el-button--save:active {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 1;
  }
}

.el-dropdown-menu {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #e8e8e8;
}

.el-dropdown-menu__item {
  font-size: 13px;
  font-weight: 700;
  color: #292929;
  height: 24px;
  padding-bottom: 8px;
}

.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus {
  cursor: default;
  background-color: initial !important;
}

.text-drop-down {
  color: #00acc1;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
</style>

<style lang="scss">
.relationship-table .el-table {
  .el-table__header-wrapper {
    padding-bottom: 6px;
  }
  th > .cell {
    font-size: 12px;
    color: #000;
    // margin-bottom: 6px;
  }
  .is-leaf {
    padding-top: 0;
    padding-bottom: 0;
    border-bottom: 1px solid #e0e0e0 !important;
  }
  td.el-table__cell {
    padding: 6px 0 6px;
  }
}

.dropdownItem-tabActivity {
  overflow-y: auto;
  max-height: 228px;
  margin-right: 12px;

  .el-checkbox__input + .el-checkbox__label {
    font-weight: 700;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    font-weight: 700;
    color: #292929;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #00bcd4;
    border-color: #00bcd4;
  }
}

.relationships-fullscreen-dialog {
  .el-dialog {
    margin: 0 !important;
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    border-radius: 0;
  }
  
  .el-dialog__body {
    padding: 0;
    height: 100vh;
  }
}
</style>
